import './index.scss'
$("#nav5").addClass("active");
$(".more").click(function () {
    $(this).parent().parent().addClass("active");
})
$(".arrow").click(function () {
    $(this).parent().toggleClass("active");
})